<template>
<div>
    <el-dialog title="报警消息"
        :visible="showPopUp"
        width="691px" 
        :modal="false" 
        :before-close="close" 
        :append-to-body="false"
        :close-on-click-modal="false"
        >
        <el-form ref="form" v-if="form" :model="form" label-width="165px" label-position="left" :class="{middleOutLine:showMap}">
            <img src="../assets/warn.gif" style="margin:20px auto;width:120px;display:block">
            <el-form-item label="报警名称" style="margin-left:155px;">
                {{form.warnName}}
            </el-form-item>
            <el-form-item label="报警时间" style="margin-left:155px;">
                {{form.startTs}}
            </el-form-item>
            <el-form-item label="报警级别" style="margin-left:155px;">
                {{form.severityTranslated}}
            </el-form-item>
            <el-form-item label="预警信息" style="margin-left:155px;">
                {{form.warnDesc}}
            </el-form-item>
            <el-form-item label="设备名称" style="margin-left:155px;">
                {{form.equipmentName}}
            </el-form-item>
            <el-form-item label="设备Code" style="margin-left:155px;">
                {{form.equipmentCode}}
            </el-form-item>
            <div class="mapBox" v-show="showMap">
              <!--  ref="map-mapview" -->
              <div class="covermap">
                <div
                  class="map"
                  id="allmapIndex"
                  style="width: 100%; height: 100%; z-index: 2 !important"
                ></div>
              </div>

              <div class="coverbg"></div>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button type="primary" v-if="form.thirdSystemCode == 'sos'" @click="queryMonitor()">查看监控</el-button> -->
            <el-button type="primary" @click="goDetail(form.id)">查看详情</el-button>
        </span>
    </el-dialog>
    <el-dialog
      class="map_popup_dialog"
      v-if="isSoSMonitorDialogVisible"
      top="30vh"
      :visible.sync="isSoSMonitorDialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="实时监控"
    >
      <div class="videoBig-item w100_h85" style="width:calc(100% - 40px);">
        <ZjHikCameraVideo
          :sysParams="sysParams"
          :cameraIndexCode="cameraId"
          :isShow="isSoSMonitorDialogVisible"
        ></ZjHikCameraVideo>
      </div>
    </el-dialog>
</div>
</template>

<script>
// import { listWarnRecord, getWarnRecordById } from '@/api/src/warnMessage'
import { getEquipmentCode, listEquipment, delEquipment, listEquipmentCategory } from "@/api/src/equipment";
import ZjHikCameraVideo from "@/components/src/HikCameraVideo";
export default {
  components: {
    ZjHikCameraVideo
  },
  props:['showPopUp','form'],
  data() {
    return {
      isSoSMonitorDialogVisible: false,
      cameraId: '',
      isShow: false,
      sysParams: {
        appkey: "",
        secret: "",
        ip: "",
        port: 443,
        videoWidth: 700,
        videoHeight: 500,
        screenWidth: 710,
        screenHeight: 510,
        cameraIndexCode: "",
      },
      mapInstance:null,
      showMap:false
    }
  },
  created() {
  },
  watch:{
    'form':{
      handler(val, oldval) {
        let center = [];
        if((val.lat && val.lng)){
          center.push(val.lng)
          center.push(val.lat)
          this.showMap=true
          this.init(() =>{
            this.onDrawMap(center)
          })
        }else if(val.coordinate){
          let coordinate = JSON.parse(val.coordinate)
          this.showMap=true
          this.init(() =>{
            this.onDrawMap('',coordinate)
          })
        }else{
          this.showMap=false
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    close(){
      this.$emit('closePopUp',{})
    },
    goDetail(warnConfigId){
      this.close()
      this.$router.push({path: '/plugin/Warn/UI/WarnRecordView', query: { warnConfigId }})
    },
    queryMonitor() {
      var that = this
      listEquipment({ pageNum: 1, pageSize: 1, equipmentCode:this.form.channelNo }).then(response =>{
          let data = response.rows[0]
          that.cameraId = data.channelNo;
          that.isSoSMonitorDialogVisible = true;
          that.sysParams = {
            appkey: data.userName,
            secret: data.userPw,
            ip: data.equipmentIp,
            port: data.equipmentPort,
            videoWidth: 600,
            videoHeight: 400,
            screenWidth: 610,
            screenHeight: 410,
            cameraIndexCode: data.channelNo,
          }
          console.log(data,that.cameraId,that.sysParams)
      });
    },
    init(fun){
      let that = this;
      var mapConfigs = {};
      this.$nextTick(function () {
        if(that.mapInstance){
          that.mapInstance.clearAll()
          fun()
        }else{
          // eslint-disable-next-line no-undef
          $(function () {
            // 不传入 syscode 和 key ，或者值为空时，
            // zjumap 插件自动从 URL 地址
            // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
            // 中读取 syscode 和 key 的值。
            // eslint-disable-next-line no-undef
            $(".map").zjumap({
              syscode: "ZJMap",
              key: "DefaultMap",
              loading: ".global-loading",
              loadingText: ".global-loading-text",
              //地图配置
              // eslint-disable-next-line no-undef
              mapConfigs: $.extend(
                {},
                {
                  mapStyle: "",
                  togglePanelVisiable: false,
                  mapLayers: "",
                  reportGeo: true,
                  // onGotGeo: function (e) {
                  //   e.handled = true;
                  //   // if (that.marker) {
                  //   //   that.marker.setPosition(
                  //   //     e.map.newPoint(e.point.lng, e.point.lat)
                  //   //   );
                  //   // } else {
                  //     //that.marker = that.addMarker(e.map, e.point);
                  //   // }
                  // },
                  // onAreaDrawn: function (e) {
                  //   that.onAreaDrawn(e.data.points);
                  // },
                  // onPolygonEditorComplete: function (e) {
                  //   that.onAreaDrawn(e.data);
                  // },
                  onMapCreated: function (e) {
                    that.mapInstance = e.map;
                    e.map.clearAll();
                    // that.center = e.map.config.center;
                    fun()
                  },
                },
                mapConfigs
              ),
            });
          });
        }
      });
    },
    onDrawMap(center,coordinate){
        var map = this.mapInstance
        if(center){
          var point = new BMap.Point(center[0] || 0, center[1] || 0);
          map.centerAndZoom(point, 12);
          var marker = new BMap.Marker(point); // 创建标注
          marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
          let labelString = "暂无法获取位置";
          if (center.length > 0) {
            labelString ="(" + center[0] + "," + center[1] + ")";
          }

          var label = new BMap.Label(labelString, {
            offset: new BMap.Size(20, -10),
          });
          marker.setLabel(label);
          map.addOverlay(marker); // 将标注添加到地图中
          map.setViewport([point]);
        }else{
          var point = new BMap.Point(coordinate[0].Longitude, coordinate[1].Latitude);
          map.centerAndZoom(point, 12);
          let pointArr = []
          coordinate.map(item =>{
            pointArr.push(new BMap.Point(item.Longitude, item.Latitude))
          })
          map.drawPolygon(pointArr, 1)
          map.setViewport(pointArr);
        }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    width: 300px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: unset !important;
   line-height: initial;
  }
  ::v-deep .el-dialog__header {
    padding-top: 14px;
  }
  ::v-deep .el-dialog__title{
    text-align: center;
  }
  ::v-deep .el-dialog__body {
    margin: 0 20px;
    padding: 0;
    // overflow: auto; 
    color: #d6f0ff;
    } 
    ::v-deep .el-form-item__content{
      text-align: left;
      font-size: 16px !important;
      color: unset;
      color: inherit !important;
      
    }  
    ::v-deep .el-form-item__label{
      font-size: 16px !important;
      font-weight: normal !important;
      color: #d6f0ff !important;
    }
    ::v-deep .el-form-item__label:before{
      color: #de8d05 !important;
    }
    ::v-deep .el-dialog__footer{
      text-align: center;
      padding-bottom: 30px;
    }
  .blue{
    color: #3affff;
  }
  .red{
     color: #f73e3e;
  }  
  .orange{
     color: #f09d18;
  }
  .yellow{
    color: #fefc36;
  }
  .mapBox {
    width: 100%;
    height: 274px;
    padding: 24px 20px 16px 26px;
    box-sizing: border-box;
    position: relative;
  }
  .covermap {
    position: absolute;
    top: 37px;
    left: 50%;
    width: 86%;
    height: 77%;
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .coverbg {
    // width: 525px;
    width: 100%;
    height: 274px;
    background: url("../assets/mapborder.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .middleOutLine{
    height: 64.8rem;
    overflow: auto;
  }
</style>
